import React, { createContext, useState } from 'react';

const StatusContext = createContext();

const StatusProvider = ({ children }) => {
  const [statustitle, setStatustitle] = useState(''); // Change the initial value as needed
  const [statusdescription, setStatusdescription] = useState(''); // Change the initial value as needed

 
  const updateStatustitle = (newStatustitle) => {
    setStatustitle(newStatustitle);
  };

  const updateStatusdescription = (newStatusdecription) => {
    setStatusdescription(newStatusdecription);
  };


  return (
    <StatusContext.Provider value={{ statustitle,
      updateStatustitle,
       statusdescription,
       updateStatusdescription,
       }}>
      {children}
    </StatusContext.Provider>
  );
};

export { StatusContext, StatusProvider };
